module.exports = __webpack_public_path__ + "static/poster-cutout-0fc0af00e1b5e45f14272435999110d5.png";